import { formatTimestamp } from "../../../../utils/helpers";

const PromptMetadata = ({ timestamp, actor, showActor }) => {
  if (!timestamp) return null;

  return (
    <div className={`flex items-center w-full px-4 mt-1 pb-2 ${showActor ? "justify-between" : "justify-end"}`}>
      {showActor && (
        <span className="photon-chat-attribution">
          {actor?.name || actor?.email || "Attribution unavailable"}
        </span>
      )}
      <time className="photon-chat-attribution" dateTime={timestamp}>
        {formatTimestamp(timestamp)}
      </time>
    </div>
  );
};

export default PromptMetadata;
